import React from "react";
import { Helmet } from "react-helmet";
import Team1 from "../../images/Team1.webp";
import Team3 from "../../images/Team3.jpeg";
import Team4 from "../../images/Team4.jpeg";
import Team5 from "../../images/Team5.jpeg";
import Team6 from "../../images/Team6.jpeg";
import Team7 from "../../images/Team7.jpeg";

function Team() {
  // Leadership Members
  const leadership = [
    { name: "Bella Seka", role: "Founder & Director", image: Team1 },
    { name: "Dora Akinyi", role: "Managing Director", image: Team3 },
  ];

  // Staff Members
  const staffMembers = [
    { name: "Cecilia Mbau", role: "Senior Nurse", image: Team7 },
    { name: "Natasha Waithera", role: "Registered Nurse", image: Team4 },
    { name: "Beatrice Wangui", role: "Registered Nurse", image: Team5 },
    { name: "Moses Muturi", role: "Physiotherapist", image: Team6 }
  ];

  return (
    <div className="team-page">
      <Helmet>
        <title>Meet Our Team | Wholistic Nursing Care Professionals</title>
        <meta name="description" content="Meet the dedicated professionals behind Wholistic Nursing Care, committed to providing exceptional home-based healthcare in Nairobi." />
        <meta name="keywords" content="nursing team Nairobi, healthcare professionals, wholistic care staff, home care specialists" />
        <link rel="canonical" href="https://wholistic.netlify.app/team" />
      </Helmet>
      <h1 className="team-title">Meet Our Team</h1>
      <p className="team-subtitle">
        Our dedicated professionals are committed to providing compassionate home care.
      </p>

      {/* ✅ Leadership Section */}
      <section className="leadership-section">
        <h2>Leadership</h2>
        <div className="team-grid leadership-grid">
          {leadership.map((leader, index) => (
            <div key={index} className="team-card leadership-card">
              <img src={leader.image} alt={leader.name} className="team-image" />
              <div className="team-overlay">
                <h3>{leader.name}</h3>
                <h4>{leader.role}</h4>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ✅ Staff Section */}
      <section className="staff-section">
        <h2>Our Staff</h2>
        <div className="team-grid">
          {staffMembers.map((member, index) => (
            <div key={index} className="team-card">
              <img src={member.image} alt={member.name} className="team-image" />
              <div className="team-overlay">
                <h3>{member.name}</h3>
                <h4>{member.role}</h4>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Team;
